import { render } from "./UltimateNews.vue?vue&type=template&id=510c3d02&scoped=true"
import script from "./UltimateNews.vue?vue&type=script&lang=js"
export * from "./UltimateNews.vue?vue&type=script&lang=js"

import "./UltimateNews.vue?vue&type=style&index=0&id=510c3d02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510c3d02"]])

export default __exports__